import { Model } from "app/pages/company-display/component/CompanyDetails/Model";
import { ModelWrapper } from "app/pages/company/component/ModelWrapper";
import { SocialShare } from "app/pages/component/SocialShare";
import AuthNavComponent from "app/pages/module/auth/AuthNav";
import Footer from "app/pages/module/Footer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Input } from "sr/helpers";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { Button } from "sr/helpers/ui-components/company/Button";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { AppDispatch } from "sr/redux/store";
import { createRedeemOrder } from "sr/utils/api/cleaner/reward/createRedeemOrder";
import { getRedeemCategory } from "sr/utils/api/cleaner/reward/getRedeemCategory";
import { getReferralWallet } from "sr/utils/api/cleaner/reward/getReferralWallet";
import { getUserFullProfile } from "sr/utils/api/user/user";

export const CheckerStatus = () => {
  const dispath = useDispatch<AppDispatch>();
  const [referLink, setReferLink] = useState<string>("");
  const [copied, setCopied] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [cleanerId, setCleanerId] = useState<string>("");
  const data = useSelector((state: any) => state.cleaner.data);
  const [wallet, setWallet] = useState(null);
  const [loader, setLoader] = useState("");
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  // useEffect(()=>{
  //     if(data?.referral_code){
  //         setReferLink(`https://app.janitorialmarketplace.org/create-cleaner?code=${data?.referral_code}`)
  //     }
  // },[data])
  useEffect(() => {
    const { user_id } = getUserDetails();
    setCleanerId(user_id);
  }, []);
  useEffect(() => {
    if (cleanerId) {
      if (data) dispath(fetchcleaner({ id: cleanerId }));
    }
  }, [cleanerId]);
  useEffect(() => {
    (async () => {
      if (cleanerId) {
        const userFullProfileRes = await getUserFullProfile();
        setUserFullProfile(userFullProfileRes?.data);
      }
    })();
  }, []);

  return (
    <>
      <AuthNavComponent isLoggedin={true}></AuthNavComponent>
      <ContentWithSpinner loader={loader === "wallet"} height="h-screen">
        {loader === "giftcardcreate" && <LoaderFullScreen></LoaderFullScreen>}
        <div className="lg:container mx-auto lg:max-w-6xl lg:my-20 mt-5 px-4 lg:px-0">
          <h1 className="text-2xl font-bold mb-3">Payment Success</h1>
          <p className="text-xl mb-5">
            Please check your email for the verification link by Checkr which is
            sent by our team to start the screening process.
          </p>

          {/* <Button
            onClick={() => setOpenPopup(true)}
            buttoncss="text-xl bg-[#ff39b3] cursor-pointer leading-[0.5]"
            padding={"p-4"}
            justify="justify-start"
            text={"Start background check"}
          ></Button> */}
        </div>
      </ContentWithSpinner>
      <Footer></Footer>
    </>
  );
};
